import { render, staticRenderFns } from "./CompanyCreating.vue?vue&type=template&id=4ecd2fd7&"
import script from "./CompanyCreating.vue?vue&type=script&lang=js&"
export * from "./CompanyCreating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports